<template>
    <svg class="mds-icon" :aria-hidden="iconAriaHidden">
        <use :xlink:href="iconPath">
            <title>{{ title }}</title>
        </use>
    </svg>
</template>

<script>
export const MDS_ICON_PATH = "";
export default {
    name: "mds-icon",
    props: {
        ariaHidden: {
            type: Boolean,
            default: true
        },
        name: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: ""
        }
    },
    computed: {
        iconAriaHidden() {
            if (this.title !== "") {
                return false;
            }
            return this.ariaHidden;
        },
        iconPath() {
            return `${MDS_ICON_PATH}#${this.name}`;
        }
    }
};
</script>
